module.exports = __webpack_public_path__ + "static/media/cfa.44d37851.png";